import "@fpsm/cxy-tokens/tokens.css?__remix_sideEffect__";

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { type Repub, REPUBS } from '@cx-modules/constants';

import MiniBetslip from '~/components/betslip/components/mini-betslip';
import Icon from '~/components/icon';
import { navItemType } from '~/constants/nav-footer-v2';
import { type MobileBottomNavItem } from '~/interfaces/HeaderFooterNavV2';
import { useServicesContext } from '~/providers/services-context';
import {
  TRACKING_ACTIONS,
  TRACKING_CATEGORIES,
  TRACKING_EVENTS } from
'~/services/actions/tracking-actions';

import styles from './MobileBottomNav.module.css';

export const MobileBottomNav = ({
  mobileBottomNavData,
  repub



}: {mobileBottomNavData: MobileBottomNavItem[];repub: Repub;}) => {
  const { t } = useTranslation(['label']);
  const { trackingActions } = useServicesContext();
  const [allSportsOpen, setAllSportsOpen] = useState(false);

  const handleEvent = (label: string): void => {
    if (label) {
      trackingActions.eventTracking({
        event: TRACKING_EVENTS.BOTTOM_NAVIGATION,
        eventCategory: TRACKING_CATEGORIES.NAVIGATION,
        eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.BOTTOM_NAVIGATION],
        eventLabel: label
      });
    }
  };

  const renderBetslipButton = () => {
    return (
      <div
        className={`${styles.menuItem}`}
        key={'Betslip'}
        onClick={() => handleEvent(t('CX_BETSLIP'))}>

				<span className={styles.iconContainer}>
					<MiniBetslip
            betslipTitle={t('RESPONSIVE_BETSLIP')}
            countryCode={REPUBS[repub].countryCode} />

				</span>
				{t('CX_BETSLIP')}
			</div>);

  };

  const renderAllSportsButton = () => {
    return (
      <button
        className={`${styles.menuItem} ${allSportsOpen ? styles.active : ''}`}
        id="all-sports-button"
        key={'allSports'}
        onClick={() => setAllSportsOpen(!allSportsOpen)}>

				<span className={styles.iconContainer}>
					<Icon height={20} icon="AmericanFootball" width={20} />
				</span>
				{t('CX_ODDS')}
			</button>);

  };

  const renderNavLink = (item: MobileBottomNavItem): JSX.Element => {
    const [icon, dimension = '20'] = (item.icon || '').split(',');

    return (
      <a
        aria-label={item.name}
        className={`${styles.menuItem} ${item.isSelected ? styles.active : ''}`}
        href={item.link}
        key={item.name}
        onClick={() => handleEvent(item.name)}>

				{icon &&
        <span className={styles.iconContainer}>
						<Icon
            height={parseInt(dimension, 10)}
            icon={icon}
            width={parseInt(dimension, 10)} />

						{item.count ?
          <span className={styles.offerCount}>{item.count}</span> :
          null}
					</span>
        }
				{item.name}
			</a>);

  };

  return (
    <nav
      aria-label="Mobile Bottom Navigation Bar"
      className={`${styles.mobileBottomNavContainer}`}
      data-testid="mobile-bottom-nav-v2">

			<div
        className={`${styles.bottomNavigation} ${allSportsOpen ? styles.open : ''}`}>

				{mobileBottomNavData.map((item: MobileBottomNavItem) => {
          switch (item.type) {
            case navItemType.ALL_SPORTS_EXPANDABLE:
              return renderAllSportsButton();
            default:
              return renderNavLink(item);
          }
        })}
				{renderBetslipButton()}
			</div>
			{/* <AllSportsMenu navData={navData} /> */}
			<div
        className={`${styles.backdrop} ${allSportsOpen ? '' : styles.off}`} />

		</nav>);

};